import React from "react";

const NewAssignmentList = ({ patients, onRemove, onAssign }) => {
	return (
		<>
			<table
				className="table display product-overview mb-30"
				id="support_table"
			>
				<thead>
					<tr>
						<th>#</th>
						<th>Image</th>
						<th>Name</th>
						<th>NHS</th>
						<th>Gender</th>
						<th>Remove</th>
					</tr>
				</thead>
				<tbody>
					{patients.map((patient, index) => {
						return (
							<tr key={index}>
								<td>{index + 1}</td>
								<td className="center patient-img">
									<img
										src={patient.profile_picture}
										alt={patient.name}
									/>
								</td>
								<td>{patient.name}</td>
								<td>
									<span className="label label-sm label-success">
										{patient.hcn}
									</span>
								</td>
								<td>
									<span className="label label-sm label-success">
										{patient.gender}
									</span>
								</td>
								<td>
									<button
										onClick={() => onRemove(patient.id)}
										className="btn btn-tbl-delete btn-xs"
										title="Remove patient"
									>
										<i className="fa fa-trash-o "></i>
									</button>
								</td>
							</tr>
						);
					})}
				</tbody>
			</table>
			<button
				onClick={onAssign}
				type="button"
				className="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect btn-circle btn-success my-3 text-center"
				style={{
					height: "44px",
					right: 0
				}}
			>
				<i class="material-icons">book</i> Assign Patients
			</button>
		</>
	);
};

export default NewAssignmentList;
